import { api } from './client'
import { getLanguage } from '../i18n'

export type CycleEvent = {
  id: string
  occurs_at: string
  // NYSE sessions away, computed per request by the server. Null for a past
  // date. The client never counts trading days itself (contract C8).
  days_until_trading?: number | null
  kind: string
  label: string
  impact?: string
  source?: string
}

export type CycleReadingKey = 'wti' | 'cpi_mom' | 'core_cpi_mom' | 'dgs10' | 'dgs2'

export type CycleReading = {
  key: CycleReadingKey
  label: string
  value: number
  unit: string
  as_of: string
  pct_rank_1y?: number | null
  trend_20d_pct?: number | null
  vs_cpi_month_pct?: number | null
  change_5d_bp?: number | null
  stat_month?: string
  release_date?: string
}

export type CycleOverlay = {
  date: string
  days_until_trading?: number | null
  type: 'option_expiry' | 'earnings' | 'ex_div'
  symbol: string
  // Per-share payment on an ex_div overlay: the last actual payment, not an
  // annualised rate. Absent on the other types.
  amount?: number | null
  position_id?: string
  holding_id?: string
  spans_event_id?: string
}

export type CyclePayload = {
  as_of: string
  events: CycleEvent[]
  readings: CycleReading[]
  overlays?: CycleOverlay[]
}

export function fetchCycle(days = 45): Promise<CyclePayload> {
  return api<CyclePayload>(`/v1/macro/cycle?days=${days}&lang=${getLanguage()}`)
}
